module.exports = __webpack_public_path__ + "static/media/cap-login-avatar-image.f2ab400b.png";